import { render, staticRenderFns } from "./dealer-canopy.vue?vue&type=template&id=035b4bfc"
import script from "./dealer-canopy.vue?vue&type=script&lang=js"
export * from "./dealer-canopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports